import ComponentModule from "@eisinc/Overrides/Components/ProductCompareFlyOut";

export * from "@eisinc/Overrides/Components/ProductCompareFlyOut";

export default ComponentModule;
